module.exports = __webpack_public_path__ + "img/39a-config-perfis-form.174e81d4.png";